import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { type AsChildProps, Slot } from "@/components/_molecules/slot.tsx";
import { useUpdateLabelGroup } from "@/domain/label/hooks/api/use-update-label-group";

type UpdateLabelGroupActionProps = AsChildProps<React.ButtonHTMLAttributes<HTMLButtonElement>> & {
  style?: React.CSSProperties;
  className?: string;
  labelGroup: {
    id: string;
    title: string;
    color: string;
    allowMultiSelect: boolean;
  };
  onSuccess?: () => void;
  onError?: () => void;
};

export const UpdateLabelGroupAction = ({
  labelGroup,
  onSuccess,
  onError,
  asChild,
  ...props
}: UpdateLabelGroupActionProps) => {
  const { t } = useTranslation("common");
  const Comp = asChild ? Slot : "button";

  const { updateLabelGroup } = useUpdateLabelGroup({
    onCompleted: () => {
      toast.success(t("label.groupUpdateSuccess"), { description: t("label.groupUpdateSuccessDescription") });
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      toast.error(t("errors.title"), { description: t("label.groupUpdateError") });
      if (onError) {
        onError();
      }
    },
  });

  async function handleClick() {
    await updateLabelGroup({
      id: labelGroup.id,
      title: labelGroup.title,
      color: labelGroup.color,
      allowMultiSelect: labelGroup.allowMultiSelect,
    });
  }

  return <Comp {...props} onClick={handleClick} />;
};
